<template>
  <v-row dense no-gutters>
    <v-col cols="8">
      <ref-components-table :value="selectedComponent" @input="onComponentChange"/>
    </v-col>
    <v-col cols="4">
      <ref-component-card :component="selectedComponent.length ? selectedComponent[0] : {}"/>
    </v-col>
    <ref-add-component-dialog v-model="dlgShowAdd" :component="selectedComponent.length ? selectedComponent[0] : {}" @compAdded="onAddComponent" @compUpdate="onAddComponent"/>
    <sys-confirm-dialog :value="dlgShowDel" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteComp"/>
  </v-row>
</template>

<script>
import RefComponentsTable from '@/components/modules/references/refComponentsTable'
import RefComponentCard from '@/components/modules/references/cards/refComponentCard'
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import RefAddComponentDialog from '@/components/modules/references/dialogs/refAddComponentDialog'
import axios from 'axios'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
export default {
  name: 'refComponentsList',
  components: { SysConfirmDialog, RefAddComponentDialog, RefComponentCard, RefComponentsTable },
  props: ['accessKey'],
  data () {
    return {
      addAction: { text: 'Добавить компонент', actionType: 'Справочник Компоненты', action: 'addComp', method: this.showAddDialog, icon: 'mdi-beaker-plus' },
      updAction: { text: 'Редактировать компонент', actionType: 'Справочник Компоненты', action: 'updComp', method: this.showEditDialog, icon: 'mdi-beaker-check' },
      delAction: { text: 'Удалить компонент', actionType: 'Справочник Компоненты', action: 'delComp', method: this.showDelDialog, icon: 'mdi-beaker-minus' },
      selectedComponent: [],
      dlgShowAdd: false,
      dlgShowDel: false
    }
  },
  watch: {
    accessKey (val) {
      console.log('Called for accessKey ', val)
      if (val !== 'forms/refComponentsList') {
        this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Справочник Компоненты' })
      } else {
        this.setActions()
      }
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Справочник Компоненты' })
      this.$store.dispatch(UI_ADD_ACTION, this.addAction)
      if (this.selectedComponent.length) {
        this.$store.dispatch(UI_ADD_ACTION, this.updAction)
        this.$store.dispatch(UI_ADD_ACTION, this.delAction)
      }
    },
    showAddDialog () {
      this.selectedComponent.splice(0, 1)
      this.dlgShowAdd = true
    },
    showEditDialog () {
      this.dlgShowAdd = true
    },
    showDelDialog () {
      this.dlgShowDel = true
    },

    cancelConfirmDialog () {
      this.dlgShowDel = false
    },
    doDeleteComp () {
      console.log('Closing confirm dialog')
      this.dlgShowDel = false
      const processorPath = '/api/org/references/delComponent.php'
      const payload = { ...this.selectedComponent[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            this.selectedComponent.splice(0, 1, { action: 'delete', COMP_ID: this.selectedComponent[0].COMP_ID })
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    onComponentChange (item) {
      this.selectedComponent.splice(0, 1, ...item)
      this.setActions()
    },

    onAddComponent (item) {
      this.onComponentChange(item)
      this.dlgShowAdd = false
    }
  },

  mounted () {
    console.log('Local components module mounted')
    this.setActions()
  }
}
</script>
